import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { BiData } from '@wix/da-bi/pkg/events';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import s from './SellYourArtLink.scss';
export const SellYourArtLink = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    const { t  } = useTranslation();
    const openModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'sell-splash'));
    }, [
        deviation,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement(ActionBarButton, {
        className: s['button'],
        onClick: openModal,
        biData: BiData({
            evid: 353,
            deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId
        })
    }, t('actionbar.sellYourArt')));
};
SellYourArtLink.displayName = 'SellYourArtLink';
export default SellYourArtLink;
